export const RESILIENCE_DB_NAME = 'analytics-web-client';
export const RESILIENCE_STORE_NAME = 'analytics-resilience';
export const TIME_TO_PROCESS_AFTER_INDEX = 'timeToBeProcessedAfter';
export const TIME_ADDED_INDEX = 'timeAdded';
export const RETRY_INDEX = 'retryAttempts';

export enum StoreType {
  INDEXEDDB = "indexeddb",
  MEMORY = "memory",
}

export enum MEMORY_DB_GUARD_POLICY {
  ABANDON_IF_LIMIT_WILL_EXECEED,
  EVICT_OLDEST_IF_LIMIT_EXECEEDED
}

export const AbandonWriteErrorName = 'AbandonWriteError';
